/**
 * @param {Event} event fired event listed
 * @param {number} currentSlide - current slide index
 * @param {number} nextSlide - next slide index
 * @param {string} direction - finds out the direction (left/right) to where the slick slides moves
 */
function sectionShapeRepositioning(event, currentSlide, nextSlide, direction) {
    const $rotatedSection = $('.section-shape .default-section');
    const $slideToBeLoaded = $(`.slick-slide[data-slick-index="${nextSlide}"]`).find('.slide');

    if ($slideToBeLoaded.hasClass('center-arch-support') || $slideToBeLoaded.hasClass('side-arch-support')) {
        $rotatedSection.addClass('horizontal').removeClass('negative-diagonal');
    } else if ($slideToBeLoaded.hasClass('heel-cup')) {
        $rotatedSection.addClass('negative-diagonal').removeClass('horizontal');
    } else {
        $rotatedSection.removeClass('horizontal negative-diagonal');
    }

    const $currentSlide = $('.footbed-section').find('.slide');
    const $prevSlide = $currentSlide.closest('.slick-current').find('.slide');
    if (direction === 'left' || $(event.target).hasClass('slick-next') || nextSlide > currentSlide) {
        $currentSlide.addClass('left-moved').removeClass('right-moved');
        $prevSlide.addClass('left-moved-passed');
        $currentSlide.removeClass('right-moved-passed');
    } else {
        $currentSlide.addClass('right-moved').removeClass('left-moved');
        $prevSlide.addClass('right-moved-passed');
        $currentSlide.removeClass('left-moved-passed');
    }
}

/**
 * @param {HTMLElement} currentContainer - current container
 * @function
 * @description Initialize differently styled slick in case footbed shape module has been loaded
 * @listens sectionShapeInitializeSlider
 */
function sectionShapeInitializeSlider(currentContainer) {
    currentContainer.slick({
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        dotsClass: 'slick-dots-custom',
        rtl: document.documentElement.lang === 'ar',
        speed: 800,
        fade: true,
        cssEase: 'linear',
        infinite: false,
        arrows: false,
        touchMove: true,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    arrows: true
                }
            }
        ]
    });
}

module.exports = {
    sectionShapeRepositioning,
    sectionShapeInitializeSlider
};
